var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"dashboard-container"}},[(_vm.querying)?_c('common-loading'):_vm._e(),_c('b-alert',{attrs:{"show":_vm.error && _vm.error.length ? true : false,"variant":"danger"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.error || '&nbsp;')}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }